import { useQuery } from '@tanstack/react-query'
import { fetchLayerSuitability } from '@app/domains/suitability/services/suitability.service'
import { LayerSuitabilityRecord } from '../types'

export const useFetchLayerSuitability = (layerId?: string) => {
  return useQuery<LayerSuitabilityRecord[]>({
    queryKey: ['layer-suitability', layerId],
    queryFn: ({ signal }) => fetchLayerSuitability(layerId as string, signal),
    enabled: Boolean(layerId),
  })
}
